import { Paper } from "matsuri-ui"
import { ReactNode } from "react"
import { theme } from "../../theme"

interface HeaderProps {
    children: ReactNode
    shadow?: boolean
}

export const Header = ({
    shadow,
    children,
    style,
    ...props
}: HeaderProps & React.HTMLAttributes<HTMLDivElement>) => {
    return (
        <Paper
            square
            elevation={shadow ? 1 : 0}
            style={{
                backgroundColor:
                    theme.palette.intentions.cleanerBackground.main,
                ...style
            }}
            {...props}
        >
            {children}
        </Paper>
    )
}
